import Vue from 'vue'
import * as allIcons from "ionicons/icons"

Vue.mixin({
  data() {
    return {
      i: allIcons
    };
  }
})